module.exports = __webpack_public_path__ + "static/image5-41a14b64569d528a499173a33d601b83.jpg";